import { useMemo } from "react"
import { useFetchPendingSubscriptionEventsQuery } from "../../../../../redux/queries"
import { PendingSubscriptionEvent } from "../../../../../types"
import { ActivityHistorySkeleton } from "../../../skeletons"
import If from "../../../if"
import ActivityRow from "./row"

type Props = {
  subscriptionId: number
}

const DreamRateActivityHistory = ({ subscriptionId }: Props) => {
  const { data: events = [], isFetching } =
    useFetchPendingSubscriptionEventsQuery({ pending_id: subscriptionId })

  // Filter out email events (they are shown in Email History tab)
  const filteredEvents = useMemo(
    () =>
      events.filter(
        (event: PendingSubscriptionEvent) =>
          event.event_type !== "pending_subscription.lo_alert_email" &&
          event.event_type !== "pending_subscription.user_alert_email"
      ),
    [events]
  )

  const sortedEvents = useMemo(
    () => [...filteredEvents].sort((a, b) => b.created - a.created),
    [filteredEvents]
  )

  return (
    <If
      condition={isFetching}
      then={<ActivityHistorySkeleton rows={3} className="mt-3" />}
      elseCondition={sortedEvents.length > 0}
      else={
        <>
          {sortedEvents.map((event: PendingSubscriptionEvent, idx: number) => (
            <ActivityRow
              key={event.id}
              event={event}
              connectorVisible={idx < sortedEvents.length - 1}
            />
          ))}
        </>
      }
      default={<div className="mt-3 text-neutral-500">No activity yet.</div>}
    />
  )
}

export default DreamRateActivityHistory
